<form [formGroup]="dateForm" *ngIf="entity && dateForm" class="mb-0" novalidate>

  <ng-container *ngIf="orientation === 'horizontal'">
    <div class="form-group row" [ngClass]="{ 'mb-0': !showLabel }">
      <!--Added by Juber -- start -->
       @if(!templateForPermitForm){
      <span
        *ngIf="showLabel"
        class="col-sm-3"
        [ngClass]="{ 'font-weight-bold': entity.isRequired }"
        >{{ entity.label }}</span
      >
      }@else{
         <wm-common-text
                [data]="{ text: showLabel ? entity?.label : '' }"
                class="header"
              >
         </wm-common-text>
      }
      <!--Added by Juber -- end -->
      <div [ngClass]="{ 'col-sm-9': showLabel }">
        <!-- Start Code edited by Sanchit on 09/10/2026 -->
        <div class="date-time-container">
          <div class="date-field">
          <!-- End Code edited by Sanchit on 09/10/2026 -->
            <!--Added by Juber -- start -->
            @if(!templateForPermitForm){
            <input
              class="form-control"
              placeholder="mm/dd/yyyy"
              [name]="entity.templateCode + '-DATE'"
              [id]="entity.templateCode + '-DATE'"
              [formControlName]="entity.templateCode + '-DATE'"
              ngbDatepicker
              #d="ngbDatepicker"
              [markDisabled]="isDisabled"
              (focus)="onFocus()"
              (dateSelect)="
                date = dateForm.controls[entity.templateCode + '-DATE'].value
              "
              [maxDate]="maxDate"
              [minDate]="minDate"
              [restoreFocus]="false"
              [autoClose]="true"
              [required]="entity.isRequired"
            />
            }@else{
              <wm-common-textfield
                [dateFilter]="materialDateFilter"
                [minDate]="convertToDate(minDate)"
                [maxDate]="convertToDate(maxDate)"
                [data]="{
                  label: showLabel ? entity.label : '',
                  placeholder: 'mm/dd/yyyy',
                  type: 'date',
                  required: entity.isRequired,
                  value: entity.value
                }"
                [formControlName]="entity.templateCode + '-DATE'"
                (valueChange)="entity.value = $event"

              ></wm-common-textfield>

          }
          <!--Added by Juber -- end -->
          </div>
          @if(!templateForPermitForm){

              <ngb-timepicker
                *ngIf="entity.includeTime"
                [id]="entity.templateCode + '-TIME'"
                [name]="entity.templateCode + '-TIME'"
                [formControlName]="entity.templateCode + '-TIME'"
                [(ngModel)]="time"
                [meridian]="true"
              ></ngb-timepicker>

          }
          @else{

              <ngb-timepicker
                *ngIf="entity.includeTime"
                [id]="entity.templateCode + '-TIME'"
                [name]="entity.templateCode + '-TIME'"
                [formControlName]="entity.templateCode + '-TIME'"
                [meridian]="true"
              ></ngb-timepicker>
          }
           <span *ngIf="entity.includeTime">&nbsp;{{ timeZoneCode }}</span>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="orientation === 'vertical'">
    <div class="form-group">
      <!--Added by Juber -- start -->
      @if(!templateForPermitForm){
      <wm-de-label
        *ngIf="showLabel"
        [entity]="entity"
        [for]="entity.templateCode + '-DATE'"
      ></wm-de-label>

      }
      <!--Added by Juber -- end -->
      <!-- Start Code edited by Sanchit on 09/10/2026 -->
      <div class="date-time-container">
        <div class="date-field">
        <!-- End Code edited by Sanchit on 09/10/2026 -->
          <!--Added by Juber -- start -->
          @if(!templateForPermitForm){
          <input
            class="form-control"
            placeholder="mm/dd/yyyy"
            [name]="entity.templateCode + '-DATE'"
            [id]="entity.templateCode + '-DATE'"
            [formControlName]="entity.templateCode + '-DATE'"
            ngbDatepicker
            #d="ngbDatepicker"
            [markDisabled]="isDisabled"
            (focus)="onFocus()"
            (dateSelect)="
              date = dateForm.controls[entity.templateCode + '-DATE'].value
            "
            [maxDate]="maxDate"
            [minDate]="minDate"
            [restoreFocus]="false"
            [autoClose]="true"
            [required]="entity.isRequired"
          />
          }@else{
              <wm-common-textfield
                [dateFilter]="materialDateFilter"
                [minDate]="convertToDate(minDate)"
                [maxDate]="convertToDate(maxDate)"
                [data]="{
                  label: showLabel ? entity.label : '',
                  placeholder: 'mm/dd/yyyy',
                  type: 'date',
                  required: entity.isRequired,
                  value: entity.value,
                  instructions: entity.instructions,
                  isHelpText: entity.instructions ? true : false
                }"
                [formControlName]="entity.templateCode + '-DATE'"
                (valueChange)="entity.value = $event"
              ></wm-common-textfield>
          }
          <!--Added by Juber -- end -->
        </div>
         @if(!templateForPermitForm){

              <ngb-timepicker
                *ngIf="entity.includeTime"
                [id]="entity.templateCode + '-TIME'"
                [name]="entity.templateCode + '-TIME'"
                [formControlName]="entity.templateCode + '-TIME'"
                [(ngModel)]="time"
                [meridian]="true"
              ></ngb-timepicker>

          }
          @else{

              <ngb-timepicker
                *ngIf="entity.includeTime"
                [id]="entity.templateCode + '-TIME'"
                [name]="entity.templateCode + '-TIME'"
                [formControlName]="entity.templateCode + '-TIME'"
                [meridian]="true"
              ></ngb-timepicker>
          }
        <span *ngIf="entity.includeTime">&nbsp;{{ timeZoneCode }}</span>
      </div>
    </div>
  </ng-container>

</form>
